import makeStyles from '@mui/styles/makeStyles';

import { colors } from '@/themesConfig/colors';

export const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.mode === 'dark';
  const backgroundColor = isDark ? colors.paleBlack : colors.whiteSmoke;
  const borderColor = isDark ? colors.darkGray : colors.silverGray;

  return {
    root: {
      width: '100%',
      height: '46px',

      display: 'flex',
      gap: theme.spacing(1),

      padding: theme.spacing(1.5, 3.5),
      borderRadius: theme.spacing(3),
      textTransform: 'none',

      backgroundColor,
      border: `1px solid ${borderColor}`,
      color: theme.palette.text.primary,

      '& p': {
        fontWeight: 600,
      },
    },
  };
});
